export default {
  api: {
    // get
    index: '/dashboard/priority-zones/',
    // post
    create: '/dashboard/priority-zones/',
    // patch
    update: (id = 'uuid') => {
      return `/dashboard/priority-zones/${id}/`
    },
    // delete
    delete: (id = 'uuid') => {
      return `/dashboard/priority-zones/${id}/`
    },
    //get
    details: (id = 'uuid') => {
      return `/dashboard/priority-zones/${id}/`
    },
    //get
    parkingModeChoices: () => {
      return `/dashboard/priority-zone-parking-mode-choices/`
    },
  },
  events: {
    name: 'priority-zone',
    // refresh-index-data
    refresh: `rid-priority-zone`,
    // slideover-right
    sorId: 'priority-zone',
    sorOpen: 'sor-open-priority-zone',
    sorClose: 'sor-close-priority-zone',
    sorToggle: 'sor-toggle-priority-zone',
    // editing-data
    editingData: 'edit-priority-zone-data',
    // viewing-data
    viewingData: 'view-priority-zone-data',
  },
}
